<template>
  <div class="footer" :class="!isPhone && isFixed ? 'fixed-footer' : ''">
    <div class="footer-container">
      <img src="../assets/logo_s@2x.png" alt="" class="logo" />
      <div>
        <ul>
          <li>
            <router-link to="/case">案例 &nbsp;·&nbsp; </router-link>
          </li>
          <li>
            <router-link to="/">首页 &nbsp; · &nbsp;</router-link>
          </li>
          <li>
            <router-link to="/dynamics">公司动态 &nbsp; ·&nbsp; </router-link>
          </li>
          <li>
            <router-link to="/about">关于我们 &nbsp;·&nbsp;</router-link>
          </li>
          <li>
            <router-link to="/contact">联系我们</router-link>
          </li>
        </ul>
        <p class="copy-right">
          ©Copyright 2021 巅峰汇影视公司版权所有 | <a href="https://beian.miit.gov.cn">粤ICP备2024264299号</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      isFixed: false,
      isPhone:false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.name === "contact") {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
  },
  methods: {
    isMobile() {
      const userAgent = window.navigator.userAgent;
      if (/Mobile|Android|iPhone|iPod|iPad|Windows Phone/i.test(userAgent)) {
        this.isPhone = true;
      } else {
        this.isPhone = false;
      }
    },
  },
  mounted(){
    this.isMobile();
  }
};
</script>
<style scoped>
.footer {
  width: 100%;
  height: 158px;
  background: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  z-index: 999;
}
.fixed-footer {
  position: fixed;
  left: 0;
  bottom: 0;
}

ul {
  display: flex;
  align-items: center;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
  height: 25px;
  font-size: 18px;
  font-family: "PingFang-SC, PingFang-SC";
  font-weight: bold;
  color: #ffffff;
  line-height: 25px;
  margin-right: 8px;
}

.logo {
  height: 65px;
}

p {
  margin-top: 15px;
  font-size: 18px;
  font-family: "PingFang-SC, PingFang-SC";
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
}

.footer-container {
  display: flex;
  align-items: center;
}

.logo {
  /* width: 71px; */
  height: 65px;
  margin-right: 28px;
}

@media screen and (max-width: 1024px) {
  .logo {
    margin-bottom: 22px;
    width: 48px;
    height: 44px;
  }
  .footer-container {
    flex-direction: column;
  }

  ul {
    justify-content: center;
  }

  p,
  a {
    font-size: 12px;
    text-align: center;
  }

  .copy-right {
    display: none;
  }

  .logo{
    margin-right: 0;
  }
}
</style>
